import styled, { css } from "styled-components";
import { FieldMessage } from "Components";

export const Input = ({
  onChange,
  value = "",
  placeholder,
  error,
  success,
  disabled,
  placeholderStyle,
  ...props
}) => {
  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <TextContainer error={error} disabled={disabled}>
      <Field
        onChange={handleChange}
        value={value}
        error={error}
        disabled={disabled}
        success={success}
        name={props.label}
        aria-label={props.label}
        id={props.label}
        {...props}
      />
      <Placeholder error={error} visible={value} htmlFor={props.label}>
        {placeholder}
        {success && (
          <FieldMessage
            content={error.message}
            type={error.status ? "error" : "success"}
            style={{
              marginTop: "0",
              marginLeft: "8px",
            }}
          />
        )}
      </Placeholder>
    </TextContainer>
  );
};

const primaryColor = "#bfbfbf";
const inputPadding = "10px 12px";
const borderRadius = "3px";
const successBorderColor = "#322FFD";
const errorBackground = "#fff";
const errorBorderColor = "#E45C52";
const errorFieldColor = "#E45C52";

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${(props) => (props.disabled ? "#A6AEB2" : "#ffffff")};
  ${(props) => props.error && `background-color: ${errorBackground};`}
  border-radius: ${borderRadius};
  position: relative;
`;

const Placeholder = styled.label`
  display: flex;
  flex-direction: row;
  color: ${(props) => (props.error ? `${primaryColor}` : `${primaryColor}`)};
  position: absolute;
  top: 12px;
  left: 12px;
  transition: all 0.2s ease-in-out;
  font-size: 14px;
  /* font-family: "AntennaRegular"; */

  ${(props) =>
    props.visible &&
    css`
      /* top: -20px;
    left: 0;
    font-size: 12px;
     */
      display: none;
    `}
`;

const Field = styled.input`
  background-color: transparent;
  border: 1px solid #808080;
  border-radius: ${borderRadius};
  outline: 0;
  padding: ${inputPadding};
  position: relative;
  width: 100%;
  -webkit-appearance: none;
  color: #000;
  z-index: 1;

  &:focus {
    border: 1px solid #322FFD;
  }

  /* &:focus + label {
    top: -20px;
    left: 0;
    padding: 0;
    font-size: 12px;
    color: ${primaryColor};
  } */

  &:disabled {
    border: 1px solid #626466;
  }

  ${(props) =>
    props.success &&
    `
    border: 1px solid ${successBorderColor};

    &:focus {
      border: 1px solid ${successBorderColor};
    }
  `}

  ${(props) =>
    props.error &&
    `
    border: 2px solid ${errorBorderColor};

    &:focus {
      border: 2px solid ${errorBorderColor};
    }
  `};
`;
